var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailsDate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5846 3.66659V2.74992C15.5846 2.24366 15.995 1.83325 16.5013 1.83325C17.0076 1.83325 17.418 2.24366 17.418 2.74992V3.66659H18.3346C19.8534 3.66659 21.0846 4.8978 21.0846 6.41658V9.16659V10.9999V15.5833C21.0846 18.6208 18.6222 21.0833 15.5846 21.0833H6.41797C3.3804 21.0833 0.917969 18.6208 0.917969 15.5833V10.9999V9.16659V6.41658C0.917969 4.8978 2.14919 3.66659 3.66797 3.66659H5.5013V2.74992C5.5013 2.24366 5.91171 1.83325 6.41797 1.83325C6.92423 1.83325 7.33464 2.24366 7.33464 2.74992V3.66659H15.5846ZM2.7513 9.16658H19.2513V6.41658C19.2513 5.91032 18.8409 5.49992 18.3346 5.49992L17.418 5.49992C17.418 6.00618 17.0076 6.41659 16.5013 6.41659C15.995 6.41659 15.5846 6.00618 15.5846 5.49992H7.33464C7.33464 6.00618 6.92423 6.41659 6.41797 6.41659C5.91171 6.41659 5.5013 6.00618 5.5013 5.49992L3.66797 5.49992C3.16171 5.49992 2.7513 5.91032 2.7513 6.41658V9.16658ZM2.7513 10.9999V15.5833C2.7513 17.6083 4.39292 19.2499 6.41797 19.2499H15.5846C17.6097 19.2499 19.2513 17.6083 19.2513 15.5833V10.9999H2.7513Z",
    fill: "#92929D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailsDate);
export default __webpack_public_path__ + "static/media/DetailsDate.de576b741d1ff5f441b62d10aed8f6f4.svg";
export { ForwardRef as ReactComponent };